import { FlaskConical, Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

interface DataCenterTabsProps {
  href: string;
  activeTab: 'upload' | 'analyses';
}

export function DataCenterTabs({ href, activeTab }: DataCenterTabsProps) {
  const { t } = useTranslation('project');
  const tabs = [
    { id: 'upload', href: `${href}/datacenter`, label: t('upload.tabLabel'), icon: Upload },
    { id: 'analyses', href: `${href}/datacenter/analyses`, label: t('analyses.tabLabel'), icon: FlaskConical },
  ] as const;

  return (
    <nav aria-label={t('viewer.dataCenter')}>
      <div className='inline-flex max-w-full flex-wrap items-center gap-0.5 rounded-md border border-border/50 bg-muted/30 p-0.5'>
        {tabs.map(({ id, href: tabHref, label, icon: Icon }) => (
          <Link
            key={id}
            data-testid={`datacenter-tab-${id}`}
            to={tabHref}
            aria-current={activeTab === id ? 'page' : undefined}
            className={cn(
              'inline-flex h-7 items-center justify-center gap-1.5 rounded-sm px-2.5 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              activeTab === id
                ? 'bg-primary font-semibold text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <Icon className='size-3.5' aria-hidden />
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
